module.exports = __webpack_public_path__ + "img/MoodBoard.a33c0790.png";